module.exports = __webpack_public_path__ + "assets/img/huazhuan.b14c1861.png";